export const locale = {
    lang: "es",
    data: {
        TAXS: {
            TAX: "Recargo comunas",
        },
    },
};
